import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDashboardFast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDashboardFast"><Path d="M18.7175 5.28249C22.4275 8.99248 22.4275 15.0075 18.7175 18.7175C15.0075 22.4275 8.99245 22.4275 5.28249 18.7175C1.5725 15.0075 1.5725 8.99246 5.28249 5.28249C8.99247 1.5725 15.0075 1.5725 18.7175 5.28249Z" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M12.1562 16.2458L15.9998 10" stroke="currentColor" strokeLinecap="square"/><Path d="M4 16.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDashboardFast;
